import * as _ from "lodash";
import {Location} from '../../utils/validators';

export const LOCATION_FORM_ADD_CHANGE = "LOCATION_FORM_ADD_CHANGE",
    RESET_LOCATION_FORM = 'RESET_LOCATION_FORM',
    RESET_LOCATION_FIELD = 'RESET_LOCATION_FIELD'

interface Action {
    payload: any,
    type: string,
    field: string,
    value?: any,
    validate: boolean
}

interface Default {
    id: number
    name: string,
}

export interface FormType {
    value: Default | {},
    error: string | boolean
}

export interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            error: any,
            min?: any,
            dirty?: boolean
        },
    }
}

const commonField  = {
    required: true,
    added: false,
    value: null,
    error: null,
    dirty: false
}

const initialState: Form = {
    valid: false,
    data: {
        court: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        department: {
            required: true,
            added: false,
            value: null,
            error: null
        },
        city: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        zip: {
            required: true,
            added: false,
            value: null,
            min: 5,
            error: null,
            dirty: false
        },
        street: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false
        },
        full_address: {
            required: false,
            added: false,
            value: null,
            error: null
        },
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);


const LocationForm = (state = initialState, action: Action) => {

    switch (action.type) {
        case LOCATION_FORM_ADD_CHANGE:
            return Location({...state.data}, action);
        case RESET_LOCATION_FORM:
            return _.cloneDeep(baseState);
        case RESET_LOCATION_FIELD:
            const copy = {...state}
            const prop = copy.data[action.field];
            if (prop) {
                copy.data[action.field] = {
                    ...prop,
                    ...commonField
                };
            }

            return copy;
        default:
            return state;
    }

};


export default LocationForm
